var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showTips)?_c('section',{staticClass:"mt-10 grey-text center"},[_c('tips',{attrs:{"qid":_vm.merchantQid,"tips-updated":_vm.tipsUpdated}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }